import { BakeShadows } from "@react-three/drei"

import { getValues } from "../helpers"
import { colors, dist, lightPosition } from "../helpers/constants"

const {
  ambientColor,
  directionalColor,
  ambientIntensity,
  directionalIntensity,
} = {
  ambientColor: colors.ambient,
  directionalColor: colors.directional,
  ambientIntensity: 0.4,
  directionalIntensity: 0.5,
}
const { x, y, z } = getValues(lightPosition)

export const Lights = () => {
  return (
    <>
      <BakeShadows />
      <ambientLight intensity={ambientIntensity} color={ambientColor} />
      <directionalLight
        color={directionalColor}
        intensity={directionalIntensity}
        castShadow
        shadow-mapSize={[1024, 1024]}
        shadow-camera-left={-dist}
        shadow-camera-right={dist}
        shadow-camera-bottom={-dist}
        shadow-camera-top={dist}
        position={[x, y, z]}
      />
    </>
  )
}
